import React, { useRef } from 'react';
import { Locations, Map, SearchBar } from './components';
import { useLocations } from './hooks';
import { Range } from './components/Range';
import styles from './styles.module.scss';
import { SearchLocation } from './components/SearchLocation';
import { useJsApiLoader } from '@react-google-maps/api';
import { wpData } from './config';
import { Library } from '@googlemaps/js-api-loader';
import { LoaderIcon } from './icons';

const App: React.FC = () => {
  const {
    radius,
    setRadius,
    locationsInArea,
    userLocation,
    handleSearch,
    radiusInMiles,
    handlePlaceChanged,
    setAutocomplete
  } = useLocations();

  const libraries = useRef(['geometry', 'places']);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: wpData.mapAPIKey,
    libraries: libraries.current as Library[]
  });

  if (loadError)
    return (
      <div className={'w-full h-full flex items-center justify-center bg-slate-50'}>
        <h5>Something went wrong please try again later!</h5>
      </div>
    );

  if (!isLoaded)
    return (
      <div className={'w-full h-full flex items-center justify-center bg-slate-50'}>
        <LoaderIcon />
      </div>
    );

  return (
    <section className={styles.app}>
      <div className={styles.appGrid}>
        <div>
          <SearchLocation
            handlePlaceChanged={handlePlaceChanged}
            setAutocomplete={setAutocomplete}
          />

          <div className={styles.appGridFilters}>
            <SearchBar onSearch={handleSearch} />
            <Range radius={radius} setRadius={setRadius} />
          </div>

          <Locations locations={locationsInArea} />
        </div>
        <Map locations={locationsInArea} radius={radiusInMiles} center={userLocation} />
      </div>
    </section>
  );
};

export default App;
